import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", path: "/" },
  { label: "影视分类", path: "/category" },
  { label: "影视资讯", path: "/news" },
];

const categoryLinks = [
  { label: "热门电影", path: "/category?type=电影" },
  { label: "热播电视剧", path: "/category?type=电视剧" },
  { label: "高分佳作", path: "/category?sort=rating" },
  { label: "最新上线", path: "/category?sort=latest" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-100 mt-auto">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2 max-w-md">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center text-primary-950 text-lg font-bold">
                道
              </span>
              <span className="font-heading text-xl font-bold text-background-50">一本道影视大全</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200">
              一本道影视大全致力于为用户提供全面、及时的影视作品信息和行业资讯，涵盖电影与电视剧多种类型。
              我们帮助每一位影迷快速找到优质作品，了解最新行业动态，享受发现好内容的乐趣。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill", "ri-youtube-fill"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-full bg-primary-800 flex items-center justify-center text-primary-200 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-3">
              {quickLinks.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-sm text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">热门频道</h4>
            <ul className="space-y-3">
              {categoryLinks.map((item) => (
                <li key={item.label}>
                  <Link to={item.path} className="text-sm text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-10 pt-6 border-t border-primary-800">
          <p className="text-xs text-primary-300">© 2025 一本道影视大全 · 本站内容为演示数据，仅用于产品展示</p>
          <div className="flex items-center gap-5">
            <span className="text-xs text-primary-300 hover:text-accent-400 transition-colors cursor-pointer">关于我们</span>
            <span className="text-xs text-primary-300 hover:text-accent-400 transition-colors cursor-pointer">用户协议</span>
            <span className="text-xs text-primary-300 hover:text-accent-400 transition-colors cursor-pointer">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}